const classButtonsConfig = [
  {
    id: 1,
    position: 2330,
    type: 'warrior',
    status: '',
  },
  {
    id: 2,
    position: 2745,
    type: 'mage',
    status: '',
  },
  {
    id: 3,
    position: 3160,
    type: 'hunter',
    status: '',
  },
];

export default classButtonsConfig;
